import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Comparativa() {
  const rows = [{
    sin: 'Horas planificando desde cero cada semana',
    con: '5 minutos. La sesión ya está lista.'
  }, {
    sin: 'Sesiones improvisadas sin progresión real',
    con: '+260 sesiones planificadas por edad'
  }, {
    sin: 'Grupos sin sistema claro de avance',
    con: 'Estructura clara para cada etapa del año'
  }, {
    sin: 'Padres que te cuestionan sin respuestas',
    con: 'Protocolo antiquejas y scripts listos'
  }, {
    sin: 'Siempre el mismo rondo. El grupo se aburre',
    con: '100 variantes para nunca repetirte'
  }, {
    sin: 'Miedo a no saber qué hacer si falta gente',
    con: 'Kit de supervivencia con plan B siempre'
  }, {
    sin: 'Sensación de improvisar siempre',
    con: 'Llegás a cada sesión con todo resuelto'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-f360-bg" data-id="element-48">
      <div className="max-w-[1000px] mx-auto" data-id="element-49">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-extrabold text-center text-gray-900 mb-16" data-id="element-50">
          ¿Cuánto cuesta NO tenerlo?
        </motion.h2>

        {/* Desktop Table */}
        <div className="hidden md:block bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden mb-16" data-id="element-51">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-52">
            <div className="p-6 text-center border-r border-gray-200" data-id="element-53">
              <h3 className="text-xl font-bold text-gray-500 flex items-center justify-center gap-2" data-id="element-54">
                <X className="w-6 h-6 text-red-500" data-id="element-55" /> Sin FÚTBOL 360
              </h3>
            </div>
            <div className="p-6 text-center bg-f360-green/5" data-id="element-56">
              <h3 className="text-xl font-bold text-f360-green flex items-center justify-center gap-2" data-id="element-57">
                <Check className="w-6 h-6" data-id="element-58" /> Con FÚTBOL 360
              </h3>
            </div>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-59">
            {rows.map((row, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="grid grid-cols-2" data-id="element-60">
                <div className="p-6 border-r border-gray-100 text-gray-600 font-medium" data-id="element-61">
                  {row.sin}
                </div>
                <div className="p-6 text-gray-900 font-bold bg-f360-green/5" data-id="element-62">
                  {row.con}
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Mobile Stacked Cards */}
        <div className="md:hidden space-y-6 mb-16" data-id="element-63">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-64">
              <div className="p-4 border-b border-gray-100 bg-gray-50 flex items-start gap-3" data-id="element-65">
                <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-66" />
                <span className="text-gray-600 font-medium" data-id="element-67">{row.sin}</span>
              </div>
              <div className="p-4 bg-f360-green/5 flex items-start gap-3" data-id="element-68">
                <Check className="w-5 h-5 text-f360-green flex-shrink-0 mt-0.5" data-id="element-69" />
                <span className="text-gray-900 font-bold" data-id="element-70">{row.con}</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-71">
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-black text-gray-900 leading-tight" data-id="element-72">
            El lunes podés improvisar
            <br data-id="element-73" />
            o entrar con todo resuelto.
            <br data-id="element-74" />
            <span className="text-f360-green mt-4 block" data-id="element-75">Vos decidís.</span>
          </h3>
        </motion.div>
      </div>
    </section>;
}